import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'

import postMessage from '@src/lib/postMessage'

import BaseBillboard from '../BaseBillboard'

// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.
// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.
const useStyles = makeStyles()(() => ({
  '@global': {
    '#beacon-container': {
      display: 'none',
    },
  },
}))

const EmbedBillboard = () => {
  useStyles()

  /** @type {React.RefObject<HTMLDivElement>} */
  const containerRef = useRef(null)
  const [previewData, setPreviewData] = useState(null)
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const id = queryParams.get('embedId')
  if (!id) {
    throw new Error('embedId missing')
  }

  // Set up channel for receiving preview data.
  useEffect(() => {
    /** @type {(event: MessageEvent) => void} */
    function handleMessage(event) {
      const data = event.data
      switch (data.type) {
        case 'embedBillboard/loadPreview':
          setPreviewData(data.payload)
          break
        default:
          break
      }
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) {
        return
      }

      postMessage(window.parent, {
        type: 'embedBillboard/size',
        payload: {
          id,
          height: entry.contentRect.height,
        },
      })
    })
    observer.observe(containerRef.current)

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Notify we are ready.
  useEffect(() => {
    postMessage(window.parent, {
      type: 'embedBillboard/ready',
      payload: { id },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** @type {JSX.Element | undefined} */
  let previewChild = undefined

  if (previewData) {
    previewChild = <BaseBillboard {...previewData.payload} />
  }

  return (
    <div ref={containerRef} style={{ maxWidth: '1152px' }}>
      {previewChild ? previewChild : 'Loading ...'}
    </div>
  )
}

export default EmbedBillboard
